import Icon from '../components/Icon.vue'

Icon.register({
  menorah: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M144 128H112C103.2 128 96 135.2 96 144V288H160V144C160 135.2 152.8 128 144 128zM240 128H208C199.2 128 192 135.2 192 144V288H256V144C256 135.2 248.8 128 240 128zM432 128H400C391.2 128 384 135.2 384 144V288H448V144C448 135.2 440.8 128 432 128zM528 128H496C487.2 128 480 135.2 480 144V288H544V144C544 135.2 536.8 128 528 128zM608 96C625.7 96 640 81.7 640 64S608 0 608 0 576 46.3 576 64 590.3 96 608 96zM512 96C529.7 96 544 81.7 544 64S512 0 512 0 480 46.3 480 64 494.3 96 512 96zM416 96C433.7 96 448 81.7 448 64S416 0 416 0 384 46.3 384 64 398.3 96 416 96zM320 96C337.7 96 352 81.7 352 64S320 0 320 0 288 46.3 288 64 302.3 96 320 96zM224 96C241.7 96 256 81.7 256 64S224 0 224 0 192 46.3 192 64 206.3 96 224 96zM128 96C145.7 96 160 81.7 160 64S128 0 128 0 96 46.3 96 64 110.3 96 128 96zM32 96C49.7 96 64 81.7 64 64S32 0 32 0 0 46.3 0 64 14.3 96 32 96zM576 288C576 305.7 561.7 320 544 320H352V144C352 135.2 344.8 128 336 128H304C295.2 128 288 135.2 288 144V320H96C78.3 320 64 305.7 64 288V144C64 135.2 56.8 128 48 128H16C7.2 128 0 135.2 0 144V288C0 341 43 384 96 384H288V448H112C103.2 448 96 455.2 96 464V496C96 504.8 103.2 512 112 512H528C536.8 512 544 504.8 544 496V464C544 455.2 536.8 448 528 448H352V384H544C597 384 640 341 640 288V144C640 135.2 632.8 128 624 128H592C583.2 128 576 135.2 576 144V288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/menorah.js
// module id = J8he
// module chunks = 144